import { REGISTER_REFERRER, REGISTER_REFERRER_SUCCESS, REGISTER_REFERRER_FAILURE } from './constants';

export function registerReferrer(data) {
	return { type: REGISTER_REFERRER, data };
}
export function registerReferrerSuccess(data) {
	return { type: REGISTER_REFERRER_SUCCESS, data };
}
export function registerReferrerFailure(error) {
	return { type: REGISTER_REFERRER_FAILURE, error };
}
